import React, { useState } from 'react';
import { ArrowMoveDownCustomIcon } from '@assets/icon';
import './FollowUpSuggestions.scss';
import { useTranslation } from 'react-i18next';

interface FollowUpSuggestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
  disabled?: boolean;
}

const FollowUpSuggestions: React.FC<FollowUpSuggestionsProps> = ({
  questions,
  onQuestionClick,
  disabled
}) => {
  const { t } = useTranslation();
  const [clickedQuestions, setClickedQuestions] = useState<Set<string>>(new Set());

  if (!questions || questions.length === 0) {
    return null;
  }

  const displayQuestions = questions.slice(0, 3);

  const handleClick = (question: string) => {
    if (clickedQuestions.has(question)) {
      return;
    }

    setClickedQuestions((prev) => new Set(prev).add(question));
    onQuestionClick(question);
  };

  return (
    <div className="follow-up-suggestions" role="list" aria-label="Suggested follow-up questions">
      <div className="follow-up-divider" aria-hidden>
        <span className="follow-up-divider-label">Gợi ý</span>
      </div>
      <div className="follow-up-header">{t('common.help')}</div>
      <div className="follow-up-list">
        {displayQuestions.map((question, index) => {
          const isClicked = clickedQuestions.has(question);
          return (
            <button
              key={index}
              className={`follow-up-question ${isClicked ? 'clicked' : ''}`}
              onClick={() => !disabled && handleClick(question)}
              disabled={isClicked || disabled}
              aria-label={`Ask: ${question}`}
              type="button"
            >
              <span className="follow-up-text">{question}</span>
              <span className="follow-up-arrow" aria-hidden>
                <ArrowMoveDownCustomIcon />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FollowUpSuggestions;
